import { Component, OnInit, OnChanges,Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Pqr } from '../../../class/pqr';
import { PqrService } from '../../../service/pqr/pqr.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { Message, FileUpload } from 'primeng/primeng';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../environments/config';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { values } from 'lodash';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-pqr',
  templateUrl: './new-pqr.component.html',
  styleUrls: ['./new-pqr.component.scss']
})
export class NewPqrComponent implements OnInit, OnChanges {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Pqr;
    @Input() verification: boolean;
    @Input() gestionSac: any;
    @Input() subPagePath: string;

    public promiseForm: Promise<any>;
    public form: FormGroup;
    public comp_attended_by_id: String;

    public es: any;

    public originOptions: SelectItem[];
    public classification_who_reportOptions: SelectItem[];
    public type_problemOptions: SelectItem[];
    public priorityOptions: SelectItem[];
    public statusOptions: {label: string, value: string, selected: boolean, disabled: boolean}[];
    // public typificationOptions: SelectItem[];

    public myEmployeeId: string;

    public disabledSolution: boolean;
    public disabledReportUser: boolean;

    public selected_department_id: string;
    public selected_venue_id: string;

    public apiUrl = config.API_ROOT;
    public msgs: Message[];

    public uploadedFileDescription: any[] = [];
    public prewiewFileDescription: any;
    public promiseFileDescription: Promise<any>;

    public uploadedFileAnswer_solution: any[] = [];
    public prewiewFileAnswer_solution: any;
    public promiseFileAnswer_solution: Promise<any>;

    constructor(
        public fb: FormBuilder,
        public pqrService: PqrService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader,
        public uploadFilesService: UploadFilesService,
        public hasPermissionService: HasPermissionService,
        private router: Router
    ) {

        this.disabledSolution = false;
        this.disabledReportUser = true;

        /*
        this.originOptions = [
            {label: 'choose', value: ''},
            {label: 'Correo', value: 'Correo'},
            {label: 'Telefónico', value: 'Telefónico'},
            {label: 'Visita', value: 'Visita'},
            {label: 'Proceso', value: 'Proceso'},
            {label: 'Aplicativo Luciana', value: 'Aplicativo Luciana'},
        ];
        */

        this.originOptions = [
            {label: 'choose', value: ''},
            {label: 'Correo electrónico', value: 'Correo electrónico'},
            {label: 'Llamada telefónica', value: 'Llamada telefónica'},
            {label: 'WhatsApp', value: 'WhatsApp'},
            {label: 'Visita', value: 'Visita'},
            {label: 'Proceso', value: 'Proceso'},
            {label: 'Aplicativo Luciana', value: 'Aplicativo Luciana'},
        ];

        this.es = calendarES();

        this.classification_who_reportOptions = [
            {label: 'choose', value: ''},
            {label: 'Empresa Usuaria', value: 'Empresa Usuaria'},
            {label: 'Trabajador En Misión', value: 'Trabajador En Misión'},
            {label: 'Trabajador De Planta', value: 'Trabajador De Planta'},
        ];

        this.type_problemOptions = this.newTypeOptions(false);

        this.priorityOptions = [
            {label: 'choose', value: ''},
            {label: 'Alta', value: 'Alta'},
            {label: 'Media', value: 'Media'},
            {label: 'Baja', value: 'Baja'},
        ];

        this.statusOptions = [
            {label: 'Abierta', value: 'Abierta', selected: true, disabled: false},
            {label: 'En Trámite', value: 'En Trámite', selected: false, disabled: false},
            // {label: 'Solucionada', value: 'Solucionada', selected: setStatusSolve, disabled: true},
            // {label: 'Cerrada', value: 'Cerrada', selected: false, disabled: false},
        ];

        if(this.hasRole(59)) {
            this.comp_attended_by_id=JSON.parse(localStorage.getItem('profile')).employee.id;
            // this.form.controls.status.disable();
            // this.type_problemOptions.splice(2, 1);
            // const index = this.type_problemOptions.findIndex(x => x.label === "No Conforme");
            // if (index !== undefined) this.type_problemOptions.splice(index, 1);

        } else{
            this.type_problemOptions.push({label: 'No Conforme', value: 'No Conforme'});
            // console.log("busque el no conforme");
        }


    }

    ngOnInit() {
        if (this.edit) {

          this.createForm(this.edit);

            if(this.hasPermission('get pqr Calidad'))
                this.disabledReportUser = false;
            else
                this.disabledReportUser = true;

            if(this.form.controls.venue_id) {
                // this.form.controls.venue_id.setValue(this.edit.venue_id);
                this.selected_venue_id = this.form.controls.venue_id.toString();
            }

            this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

            let setStatusOpen = true;
            // let setStatusClose = false;
            let setStatusSolve = false;
            let setStatusVerify = false;
            let setStatusInProcedure = false;

            if (this.edit.status === 'Abierta')
                setStatusOpen = true;

            if (this.edit.status === 'En Trámite')
                setStatusInProcedure = true;

            // if (this.edit.status === 'Cerrada')
            //     setStatusClose = true;

            if (this.edit.status === 'Solucionada')
                setStatusSolve = true;

            if (this.edit.status === 'Verificada')
                setStatusVerify = true;

            if (this.myEmployeeId === this.edit.attended_by_id) {
                // this.form.get('answer_solution').disable();
                // this.form.get('date_solution').disable();
                this.disabledSolution = true;

                setStatusOpen = true;

                this.statusOptions = [
                    {label: 'Abierta', value: 'Abierta', selected: setStatusOpen, disabled: false},
                    {label: 'En Trámite', value: 'En Trámite', selected: setStatusInProcedure, disabled: false},
                ];
            }

            if (this.myEmployeeId == this.form.controls.report_user_id.value) {
                this.statusOptions = [
                    {label: 'Abierta', value: 'Abierta', selected: setStatusOpen, disabled: true},
                    {label: 'En Trámite', value: 'En Trámite', selected: setStatusInProcedure, disabled: false},
                    {label: 'Solucionada', value: 'Solucionada', selected: setStatusSolve, disabled: false},
                ];
            }

            if (this.verification) {
                this.statusOptions = [
                    {label: 'Abierta', value: 'Abierta', selected: setStatusVerify, disabled: false},
                    {label: 'En Trámite', value: 'En Trámite', selected: setStatusInProcedure, disabled: false},
                    // {label: 'Cerrada', value: 'Cerrada', selected: setStatusClose, disabled: false},
                    {label: 'Solucionada', value: 'Solucionada', selected: setStatusSolve, disabled: false},
                    {label: 'Verificada', value: 'Verificada', selected: setStatusVerify, disabled: false},
                ];
                this.disabledSolution = false;
                this.disabledReportUser = false;
            }

            // this.status.setValue(this.edit.status);
            this.form.get('date_solution').disable();

            if (!this.verification && !this.hasPermission('get pqr Calidad')) {
                this.form.get('origin').disable();
                this.form.get('report_by').disable();
                this.form.get('classification_who_report').disable();
                this.form.get('type_problem').disable();
                this.form.get('department_id').disable();
                this.form.get('typification').disable();
                this.form.get('description').disable();
                this.form.get('priority').disable();
                this.form.get('answer_solution').disable();
                // this.form.get('date_solution').disable();
            }
            // else {
            //     this.form.get('origin').setValidators([]);
            //     this.form.get('report_by').setValidators([]);
            //     this.form.get('classification_who_report').setValidators([]);
            //     this.form.get('type_problem').setValidators([]);
            //     this.form.get('department_id').setValidators([]);
            //     this.form.get('typification').setValidators([]);
            //     this.form.get('description').setValidators([]);
            //     this.form.get('priority').setValidators([]);
            //     this.form.get('worked_by_id').setValidators([]);
            //     this.form.get('answer_solution').setValidators([]);
            //     // this.form.get('date_solution').setValidators([]);
            //     this.form.get('date_verification_answer').setValidators([]);
            // }

            if (this.myEmployeeId == this.edit.report_user_id) {
                this.form.get('answer_solution').enable();
            }

            if (this.edit.file_description) {
                this.uploadedFileDescription = [];
                this.uploadedFileDescription.push({'name': 'Archivo Adjunto'});
            }

            if (this.edit.file_answer_solution) {
                this.uploadedFileAnswer_solution = [];
                this.uploadedFileAnswer_solution.push({'name': 'Archivo Adjunto'});
            }
        } else {
            this.createForm();

            if  (!this.gestionSac && !this.hasRole(59))
                this.form.get('attended_by_id').setValidators([Validators.required]);

            this.form.get('report_user_id').setValidators([Validators.required]);

            this.disabledReportUser = false;

        }

    }

    public createForm(data:any = null)
    {
        data = data || {
            id: undefined,
            attended_by_id: null,
            origin: '',
            venue_id: null,
            report_by: '',
            classification_who_report: '',
            company_id: null,
            type_problem: '',
            department_id: null,
            typification_id: null,
            report_user_id: null,
            description: '',
            answer_solution: '',
            priority: '',
            worked_by_id: null,
            created_at: null,
            date_process: null,
            date_solution: null,
            days: '',
            date_verification_answer: null,
            verified_by_id: null,
            status: '',
            gestion_sac_id: null,
            cost: '0',
            cost_assumed_by: null
        };

        var rol_company = this.hasRole(59);

        this.form = this.fb.group({
            id: new FormControl(data.id),
            attended_by_id: new FormControl(data.attended_by_id, Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
            origin: new FormControl({value: data.origin, disabled: rol_company}, rol_company ? []: Validators.compose([Validators.required, Validators.minLength(1)])),
            venue_id: new FormControl({value: data.venue_id, disabled: rol_company}, rol_company ? []: Validators.compose([Validators.required, Validators.minLength(1)])),
            report_by: new FormControl( {value: data.report_by, disabled: rol_company}, rol_company ? [] : Validators.compose([ Validators.required, Validators.minLength(5) ]) ),
            classification_who_report: new FormControl({value: data.classification_who_report, disabled: rol_company}, rol_company ? []: Validators.compose([Validators.required, Validators.minLength(1)])),
            company_id: new FormControl(data.company_id, Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
            type_problem: new FormControl(data.type_problem, Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
            department_id: new FormControl({value: data.department_id, disabled: rol_company}, rol_company ? [] : Validators.compose([Validators.required, Validators.minLength(1)])),
            typification: new FormControl({value: data.typification_id, disabled: rol_company}, rol_company ? [] : Validators.compose([Validators.required, Validators.minLength(1)])),
            report_user_id: new FormControl({value: data.report_user_id, disabled: rol_company}, rol_company ? [] : Validators.compose([Validators.required, Validators.minLength(1)])),
            description: new FormControl(data.description, Validators.compose([ Validators.required, Validators.minLength(10) ]) ),
            answer_solution: new FormControl(data.answer_solution),
            priority: new FormControl(data.priority, Validators.compose([ Validators.required, Validators.minLength(1) ]) ),
            worked_by_id: new FormControl(data.worked_by_id),
            created_at: new FormControl(data.created_at ? new Date(data.created_at) : null),
            date_solution: new FormControl(data.date_solution ? new Date(data.date_solution) : null),
            date_process: new FormControl(data.date_process ? new Date(data.date_process) : null),
            days: new FormControl(data.days),
            date_verification_answer: new FormControl(data.date_verification_answer ? new Date(data.date_verification_answer) : null),
            verified_by_id: new FormControl(data.verified_by_id),
            status: new FormControl({value: data.status, disabled: rol_company}),   // status: new FormControl(data.status),
            cost: new FormControl((data.cost != null && !isNaN(data.cost)) 
                                    ? data.cost.toLocaleString('en-US') : '0'),
            cost_assumed_by: new FormControl(data.cost_assumed_by)
        });
    }


    ngOnChanges() {
        this.ngOnInit();
    }

    public cancelPqr () {
        // console.log('reset');
        this.form.reset();
        this.close.emit(true);
        // this.router.navigate(['/pages/pqrs/pqrs_asigned']);
        switch (this.subPagePath) {
            case 'pqrs_reported':
                this.router.navigate(['/pages/pqrs/pqrs_reported']);
            break;

            case 'pqrs_asigned':
                this.router.navigate(['/pages/pqrs/pqrs_asigned']);
            break;

            case 'pqrs_verification':
                this.router.navigate(['/pages/pqrs/pqrs_verification']);
            break;
        }
    }

    public newPqr(values) {

        if (!values.status) {
            values.status = 'Abierta';
        }

        // let company_id = null, attended_by_id = null, report_user_id = null, worked_by = null, verified_by = null;

        if (this.edit) {
            values.date_process = this.statusDate(this.edit.date_process, values.status, 'En Trámite');
            values.date_solution = this.statusDate(this.edit.date_solution, values.status, 'Solucionada');
            values.date_verification_answer = this.statusDate(this.edit.date_verification_answer, values.status, 'Verificada');
        } else {
            if (this.gestionSac) {
                if (this.gestionSac.company_id)
                    values.company_id = this.gestionSac.company_id;

                if (this.gestionSac.employee_id)
                    values.attended_by_id = this.gestionSac.employee_id;

            } else {
                if (this.hasRole(59)) {
                    values.attended_by_id = this.comp_attended_by_id;
                }
            }
        }

        if(values.attended_by_id){
          if(values.attended_by_id.id){
            values.attended_by_id = values.attended_by_id.id;
          }
        }

        if (this.gestionSac) {
            values.gestion_sac_id = this.gestionSac.id;
        }

        values.id = values.id == null ? undefined : values.id;
        values.typification_id = values.typification;
        values.worked_by_id = values.worked_by_id ? values.worked_by_id.id : values.worked_by_id;
        values.company_id = values.company_id ? values.company_id.id : values.company_id;
        // values.attended_by_id = values.attended_by_id ? values.attended_by_id.id : values.attended_by_id;
        values.report_user_id = values.report_user_id ? values.report_user_id.id : values.report_user_id;
        values.verified_by_id = values.verified_by_id ? values.verified_by_id.id : values.verified_by_id;
        values.date_process = (values.date_process == '') ? null : values.date_process;
        values.date_solution = (values.date_solution == '') ? null : values.date_solution;
        values.cost = values.cost.toString().replace(/[\.,]/g, '');
        values.cost_assumed_by = values.cost_assumed_by ? values.cost_assumed_by.id : values.cost_assumed_by;

        if (this.verification) {
            values.date_verification_answer = (values.date_verification_answer == '') ? null : values.date_verification_answer;
            // values.verified_by_id = verified_by;
        }

        if (values && this.form.valid) {
            const promise = (this.edit) ? this.pqrService.updatePqr(this.edit.id, values) : this.pqrService.newPqr(values);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        this.edit = response.json();
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public selectedDepartment(values) {
        this.form.controls.typification.setValue('');
        if (values) {
            this.selected_department_id = values;
            if(values == '1') {
                this.type_problemOptions = this.newTypeOptions(true);
            } else {
                this.type_problemOptions = this.newTypeOptions(false);
            }
        }
    }
    public newTypeOptions (ValueQuestion){
        if(ValueQuestion){
            var newOptions =
            [
                {label: 'choose', value: ''},
                {label: 'Queja', value: 'Queja'},
                {label: 'Felicitación', value: 'Felicitación'},
            ];
        }
        else{
            var newOptions = 
            [
                {label: 'choose', value: ''},
                {label: 'Queja', value: 'Queja'},
                {label: 'Solicitud', value: 'Solicitud'},
                {label: 'Felicitación', value: 'Felicitación'},
            ];
        }
        if (!this.hasRole(59)){
            newOptions.push({label: 'No Conforme', value: 'No Conforme'});
        }
        return newOptions;
    }

    public selectedVenue(values) {
        // this.typification.setValue('');
        // if (values) {
        //     this.selected_venue_id = values;
        // }
    }

    public checkOtherValidation (values) {
        let check = false;
        if (this.edit) {
            if (values) {
                if (values.status == 'Abierta') {
                    if (this.verification)
                        check = true;
                } else if (values.status == 'En Trámite'){
                    check = false;
                    if (values.answer_solution != '' && values.answer_solution != null) {
                        if(values.worked_by_id != '' && values.worked_by_id != null && values.worked_by_id != undefined)
                            check = true;
                    }
                } else if (values.status == 'Solucionada') {
                    check = false;
                    if (values.answer_solution != '' && values.answer_solution != null) {
                        if(values.worked_by_id != '' && values.worked_by_id != null && values.worked_by_id != undefined)
                            check = true;
                    }

                } else if (values.status == 'Verificada') {
                    check = false;
                    if (values.verified_by_id != '' && values.verified_by_id != null && values.verified_by_id != undefined)
                        check = true;

                }
            }

        } else {
            if (values) {
                if (values.company_id ) {
                    if (values.company_id.id) {
                        check = true;
                    } else {
                        return false;
                    }
                }
                if (this.gestionSac) {
                  if (this.gestionSac.company_id) {
                      check = true;
                  } else {
                      return false;
                  }
                }
            }
        }
        return check;
    }

    public onUploadFileDescription(event: any) {
        this.uploadedFileDescription = [];
        for (const file of event.srcElement.files) {
            this.uploadedFileDescription.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewFileDescription = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateFileDescription(event: any) {
        this.uploadedFileDescription = [];
        for (const file of event.files) {
            this.uploadedFileDescription.push(file);
        }

        this.promiseFileDescription = this.uploadFilesService.updateFileDescription(this.uploadedFileDescription, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                // this.getProfile();
                // this.avatar = this.prewiewFileDescription;
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    public gotoFileDescription() {
        window.open(this.apiUrl + '/pqrs/' + this.edit.id + '/file-description?'+
        'token=' + localStorage.getItem('token'), '_blank');
    }

    public downloadFileDescription() {
        this.promiseFileDescription = this.uploadFilesService.getFileDescription(this.edit.id).toPromise().then(
            response => {
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    public onUploadFileAnswer_solution(event: any) {
        this.uploadedFileAnswer_solution = [];
        for (const file of event.srcElement.files) {
            this.uploadedFileAnswer_solution.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewFileAnswer_solution = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateFileAnswer_solution(event: any) {
        this.uploadedFileAnswer_solution = [];
        for (const file of event.files) {
            this.uploadedFileAnswer_solution.push(file);
        }

        this.promiseFileAnswer_solution = this.uploadFilesService.updateFileAnswer_solution(this.uploadedFileAnswer_solution, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                // this.getProfile();
                // this.avatar = this.prewiewFileAnswer_solution;
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    public gotoFileAnswer_solution() {
        window.open(this.apiUrl + '/pqrs/' + this.edit.id + '/file-answer_solution?'+
        'token=' + localStorage.getItem('token'), '_blank');
    }

    public downloadFileAnswer_solution() {
        this.promiseFileAnswer_solution = this.uploadFilesService.getFileAnswer_solution(this.edit.id).toPromise().then(
            response => {
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }
    public hasRole(rol){
        var r: boolean=false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){
            r = true;
        }
        return (r);
    }

    public statusDate(date_edit: any, status: string, status_req) {
        var date_ret = null;

        if (date_edit == null || date_edit == '') {
            if (status == status_req)
                date_ret = formatDate(new Date());
        } else
            date_ret = date_edit;
        return date_ret;
    }

    public getStatusObject(eventObjetc, nameObject: string){
        var status = false;
        if(eventObjetc) {
          if (eventObjetc.value == nameObject)
            status = true;
        }
        return status;
    }

    formatNumber(name: string): void {
        // const itemFormGroup = this.status_tracking.at(statusTrackingIndex) as FormGroup;
        // const control = itemFormGroup.get('received_amount');
        const control = this.form.get(name);
        if (control.value) {
          // Elimina las comas existentes
          const numericValue = parseFloat(control.value.replace(/,/g, ''));
          if (!isNaN(numericValue)) {
            // Formatea el valor y actualiza el FormControl
            control.setValue(numericValue.toLocaleString('en-US'), {
              emitEvent: false // Evita ciclos infinitos de eventos
            });
          }
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqrs/new-pqr/new-pqr.component.ts